import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import React from "react";
import { styled } from "@mui/material/styles";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { Icon, VisuallyHidden } from "@sequentech/ui-essentials";
import { useTranslation } from "react-i18next";
var MemberItem = styled("li")(function (_a) {
    var theme = _a.theme;
    return ({
        "display": "flex",
        "alignItems": "baseline",
        "gap": "8px",
        "listStyle": "none",
        "margin": "0 -6px",
        "padding": "3px 6px 3px 29px",
        "borderRadius": "4px",
        "overflowWrap": "anywhere",
        "&.slate-member-selected": {
            paddingLeft: "6px",
            fontWeight: 700,
            color: theme.palette.green.main,
            backgroundColor: theme.palette.green.light,
        },
        "& .slate-member-check": {
            flex: "0 0 15px",
            fontSize: "0.8125rem",
        },
    });
});
export var SlateMember = function (_a) {
    var selected = _a.selected, candidateId = _a.candidateId, className = _a.className, children = _a.children;
    var t = useTranslation().t;
    return (_jsxs(MemberItem, { className: ["slate-member", selected ? "slate-member-selected" : "", className !== null && className !== void 0 ? className : ""]
            .filter(Boolean)
            .join(" "), "data-candidate-id": candidateId, children: [selected && _jsx(Icon, { className: "slate-member-check", icon: faCheck, "aria-hidden": "true" }), _jsx("span", { className: "slate-member-name", children: children }), selected && (_jsx(VisuallyHidden, { className: "slate-member-selected-label", component: "span", children: t("slates.selection.selected") }))] }));
};
